import React from "react";
import { useAppSelector } from "@/store/store";
import AppBar from "./../../components/DefaultAppBar";
import PropertyManagementProfile from "./PropertyManagementProfile";
import EstateSelectToolbar from "../../components/EstateSelectToolbar";
import DocumentLayout from "./../../components/Layouts/DocumentLayout";

const route = "/property-management";

function PropertyManagementContainer() {
  const propertyManagement = useAppSelector(
    (state) => state.propertyManagement,
  );

  return (
    <div>
      <AppBar position="static">
        <EstateSelectToolbar noTicketFilter />
      </AppBar>
      <DocumentLayout>
        <PropertyManagementProfile estate={propertyManagement} />
      </DocumentLayout>
    </div>
  );
}

PropertyManagementContainer.route = route;

export default PropertyManagementContainer;
